<template>
    <div class="navPC_09m">
        <div class="nav">
            <div class="logo">
                <img src="../../public/img/logo_09m.png" alt="" srcset="">
            </div>
            <div class="items" ref="items">
                <div class="item" v-for="(item, index) in items" :key="index" @click.stop="openHome(item)">
                    {{$t(item.name)}}
                    <div class="item_info" v-if="item.list.length>0">
                        <div class="item_info_box">
                            <div class="item_info_box_btn" v-for="(_item, _index) in item.list" :key="_index+20" @click.stop="openWin(_item,item.name)">{{$t(_item.name)}}</div>
                        </div>
                    </div>
                    <div class="under_line"></div>
                </div>
            </div>
            <div class="lang">
                <div class="lang_box">
                    <div class="lang_box_show">
                        <div class="lang_box_img">
                            <img :src="`${baseUrl}img/country/${conturl}`" alt="" srcset="">
                        </div>
                        <div class="lang_box_text">{{$i18n.locale=='en'?'English':'Chinese'}}</div>
                        <div class="lang_box_more">
                            <img src="../../public/img/country/more.png" alt="" srcset="">                            
                        </div>                                                
                    </div>
                    <div :class="`lang_box_show ${$i18n.locale=='en'?'isThis':''}`" @click="$root.$i18n.locale = 'en'">
                        <div class="lang_box_img">
                            <img  src="../../public/img/country/English.png" alt="" srcset="">
                        </div>
                        <div class="lang_box_text">English</div>
                        <div class="lang_box_more"></div>                                                
                    </div>
                    <div :class="`lang_box_show ${$i18n.locale=='zh'?'isThis':''}`" @click="$root.$i18n.locale = 'zh'">
                        <div class="lang_box_img">
                            <img src="../../public/img/country/Chinese.png" alt="" srcset="">
                        </div>
                        <div class="lang_box_text">Chinese</div>
                        <div class="lang_box_more"></div>                                                
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"navPC_09m",
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            items:[{
                name:"HOME",
                list:[]
            },{
                name:"navAbout",
                list:[
                    {name:"誉诚简介",url:"/Introduction"},
                    {name:"发展历程",url:"/development"},
                    {name:"分子公司",url:"/Branch"},
                    {name:"资质证书",url:"/certificate"}                                        
                ]                
            },{
                name:"下载",
                list:[                   
                ]                
            },{
                name:"products",
                list:[
                    {name:"一次性防护服",classId:1},
                    {name:"实验服",classId:2},     
                    {name:"隔离衣",classId:3,pid:13},                    
                    // {name:"一次性防护口罩",classId:4,pid:15},       
                    {name:"一次性防护口罩",classId:4},
                    {name:"透气膜头套",classId:5},                    
                    {name:"胡须套",classId:6,pid:18},                    
                    {name:"条帽",classId:7,pid:19},                    
                    {name:"袖套",classId:8},                    
                    {name:"靴套",classId:9},
                    {name:"鞋套",classId:10}, 
                    {name:"PE塑料手套",classId:11,pid:29},                                         
                ]                
            },{
                name:"news",
                list:[
                    {name:"新闻动态",url:"/news"},                    
                    {name:"视频中心",url:"/videoCenter"},                                        
                ]                                
            },{
                name:"contact",
                list:[
                    {name:"联系方式",url:"/contact"},                                        
                    {name:"誉诚商城",url:"https://xtyucheng.en.alibaba.com/zh_CN/?spm=a2700.icbuShop.88.10.526c4b3aQhdR7W"},                                           
                ]                                
            }]
        }
    },
    computed:{
        conturl(){
            
            if(this.$i18n.locale=='zh'){
                return 'Chinese.png'
            }else if(this.$i18n.locale=='en'){
                return 'English.png'
            }
        }
    },
    methods:{
        setLang(){
            this.$root.$i18n.locale == 'zh'?this.$root.$i18n.locale = 'en':this.$root.$i18n.locale = 'zh'
        },
        openHome(item){
            
            if(item.name=='HOME'){
                this.$router.push('/')
            }
            if(item.name === '下载'){
                this.$router.push('/download')
            }
            if(item.name=='products'){
                this.$router.push('/productClass')
            }
        },
        turnClass(id){
            this.$router.push({
                path:"/productClass_info_class",//这个path就是你在router/index.js里边配置的路径
                query:{
                    classId:id,
                }
            })
            // this.$router.go(0)
        },
        turnPro(cid,pid){
            this.$router.push({
                path:"/productClass_info",//这个path就是你在router/index.js里边配置的路径
                query:{
                    classId:cid,
                    productId:pid
                }
            })

            // 
        },
        openWin(item,name){
            if(name=='products'){
                if(item.pid){
                    this.turnPro(item.classId,item.pid)
                }else{
                    this.turnClass(item.classId)
                }
            }else if(item.name=='誉诚商城'){
                window.open(item.url); 
            }
            else{
                this.$router.push(item.url)
            }
        }
    },
    mounted(){
        this.$refs.items.childNodes.forEach(element => {
            $api.addEvt(element, 'mouseover', function(){
                try {
                    let item_info = element.getElementsByClassName('item_info')[0]
                    item_info.style.display = 'block'
                    let item_info_box = item_info.getElementsByClassName('item_info_box')[0]
                    let height = $api.offset(item_info_box).h;
                    item_info.style.height = height+'px'
                } catch (error) {
                    
                }
            });
            $api.addEvt(element, 'mouseout', function(){
                try {
                    let item_info = element.getElementsByClassName('item_info')[0]
                    item_info.style.display = 'none'
                    item_info.style.height = 0+'px'
                } catch (error) {
                    
                }
            });
        });
        // let items = $api.offset(this.$refs.items);
    }
}
</script>
<style lang="less">
.navPC_09m{
    height: 5vw;
    width: 100vw;
    background-image: linear-gradient(to right, rgba(0,51,2,0.85) , rgba(0,56,80,0.85) 40%);
    position: fixed;
    letter-spacing: 0.05rem;
    z-index: 1000;
    top: 0;
    left: 0;
    white-space:nowrap;
    .isThis{
        opacity: 0.5;
    }
    // font-family: 'YHBD';
    .nav{
        width: 73%;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .logo{
            width: 23%;
            height: 100%;
            display: flex;
            align-items: center;
            align-content: left;
            img{
                width: 90%;
            }
        }
        .items{
            width: 59.5%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .item{
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-family: "YHBD";
                font-weight: bold;
                // background-color: red;
                width: 16%;
                height: 100%;
                white-space:nowrap;
                font-size: 0.8vw;
                text-align: center;
                color: #ffffff;
                position: relative;
                &:hover{
                    &{
                        .under_line{
                            opacity: 1;                            
                        }
                    }
                }
                .under_line{
                    width: 60%;
                    position: absolute;
                    left: 50%;
                    height: 2px;
                    background-color: #ffffff;
                    bottom: 1vw;
                    opacity: 0;
                    transition: 0.3s all ease-in-out;
                    transform: translate(-50%,0);
                }
                .item_info{
                    position: absolute;
                    width: fit-content;
                    height: 0px;
                    transition: 0.3s all ease-in-out;
                    overflow: hidden;
                    bottom: 1px;
                    left: 0%;
                    transform: translate(0,100%);
                    display: none;
                    background-color: rgba(0,56,80,0.85);
                    // background-color: red;
                    border-radius: 0 0 5px 5px;
                    .item_info_box{
                        width: fit-content;                        
                        height: fit-content;
                        padding: 15px;
                        text-align: left;
                        padding-bottom: 10px;
                        .item_info_box_btn{
                            // font-family: 'YHBD';
                            // font-family: 'YH';   
                            // font-weight: 1;                         
                            margin-bottom: 10px;                      
                            letter-spacing: 1px;

                        }
                    }
                }
            }
        }
        .lang{
            width: 17.5%;
            height: 100%;
            position: relative;
            .lang_box{
                width: fit-content;
                height: 2vw;
                background-color: rgba(0, 0, 0, 0.64);
                position: absolute;
                top: 1.5vw;
                right: 0;
                border-radius: 1vw;
                cursor: pointer;
                overflow: hidden;
                transition: 0.2s all ease-in-out;
                &:hover{
                    height: 6vw;
                }
                .lang_box_show{
                    width: fit-content;
                    height: 2vw;
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    padding-left: 1.5vw;
                    padding-right: 1vw;
                    .lang_box_img{
                        width: 1.5vw;
                        display: flex;
                        margin-right: 10px;
                        background-color: red;                        
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 100%;
                        }
                    }
                    .lang_box_text{
                        color: #ffffff;
                        font-family: "YHBD";
                        font-size: 0.8vw;
                        // margin: 0px 5px;
                    }
                    .lang_box_more{
                        width: 1.5vw;
                        display: flex;
                        // background-color: red;
                        margin-left: 10px;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 100%;
                        }
                        // background-color: red;
                    }
                }
            }
        }
    }
    
}
</style>

<i18n>
{
  "en": {
      "navAbout":"ABOUT US",
      "products":"PRODUCTS",
      "news":"NEWS",
      "HOME":"HOME",
       "contact":"CONTACT US",
       "誉诚简介":"Yu Cheng",
       "发展历程":"Development",
       "分子公司":"Branch",
       "资质证书":"Certificate",
       "医疗防护":"Medical Protection",
       "防护服":"Protective Suit",
       "防护服反光条":"Protective Clothing Seal",
       "手术衣":"Surgical Gown",
       "无纺布帽":"Non-woven Hat",
       "一次性鞋套":"Disposable Shoe Sover",
       "口罩":"Masks",
       "日常护理":"Daily Care",
       "酒店浴袍":"Hotel Bathrobe",
       "袖套":"Cuff",
       "工作服":"Disposable Coverall",
       "新闻动态":"News",
       "视频中心":"Video Center",
       "联系方式":"Contact Information",
       "誉诚商城":"Yucheng Mall",
       "关于业务":"BUSINESS",
       "下载": "DOWNLOAD",
       "国内业务":"Domestic Business",
       "国际业务":"International Business",
       "一次性防护服":"Disposable Coverall",
       "实验服":"Disposable Lab Coat",
       "隔离衣":"Disposable Isolation Gown",
       "一次性防护口罩":"Disposable Face Mask",
       "透气膜头套":"Microporous Hood",
       "胡须套":"Beard Cover",
       "条帽":"Bouffant Cap",    
       "袖套":"Microporous Sleeve Cover",       
       "靴套":"Disposable Boot Cover",       
       "鞋套":"Shoe Cover",
       "PE塑料手套":"Plastic Gloves"
  },
  "zh": {
       "navAbout":"关于誉诚",
       "products":"产品中心",
       "news":"新闻中心",
       "HOME":"主页",
       "contact":"联系我们",
       "誉诚简介":"誉诚简介",
       "发展历程":"发展历程",
       "分子公司":"分子公司",
       "资质证书":"资质证书",
       "医疗防护":"医疗防护类",
       "防护服":"防护服",
       "防护服反光条":"防护服反光条",
       "手术衣":"手术衣",       
       "无纺布帽":"无纺布帽",
       "一次性鞋套":"一次性鞋套",
       "口罩":"口罩",
       "日常护理":"日常护理类",
       "酒店浴袍":"酒店浴袍",
       "袖套":"袖套", 
       "工作服":"一次性防护服",
       "新闻动态":"新闻动态", 
       "视频中心":"视频中心",
       "联系方式":"联系方式",
       "誉诚商城":"誉诚商城",
       "关于业务":"关于业务",
       "下载": "下载",
       "国内业务":"国内业务",
       "国际业务":"国际业务",
       "一次性防护服":"一次性防护服",
       "实验服":"实验服",
       "隔离衣":"隔离衣",
       "一次性防护口罩":"一次性防护口罩",
       "透气膜头套":"透气膜头套",
       "胡须套":"胡须套",
       "条帽":"条帽",    
       "袖套":"袖套",       
       "靴套":"靴套",       
       "鞋套":"鞋套",
       "PE塑料手套":"PE塑料手套"
    }
}
</i18n>